import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_URL } from '../../config/apiConfig';
import { getPasswordEndpoints } from '../../utils/passwordEndpoints';

const SendOtp = ({ role }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const computedRole = role || (typeof window !== 'undefined' ? (window.location.pathname.split('/')[1] || 'user') : 'user');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return toast.error('Please enter your email');

    setLoading(true);
    try {
      const endpoints = getPasswordEndpoints(computedRole);
      const res = await axios.post(endpoints.sendOtpUrl, { email });
      if (res.data && res.data.success) {
        toast.success(res.data.message || 'OTP sent to your email');
        navigate(`/${computedRole}/reset-password`, { state: { email } });
      } else {
        toast.error(res.data?.message || 'Failed to send OTP');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || err.message || 'Error sending OTP');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="max-w-md w-full bg-white p-6 rounded shadow-md">
        <h2 className="text-xl font-semibold mb-4">Forgot Password</h2>
        <p className="text-sm text-gray-600 mb-4">Enter your email to receive a password reset OTP.</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="relative">
            <input
              type="email"
              className="w-full border rounded px-3 py-2"
              placeholder="Your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button type="submit" className={`w-full py-2 rounded ${loading ? 'bg-gray-400' : 'bg-blue-600 text-white'}`} disabled={loading}>
            {loading ? 'Sending...' : 'Send OTP'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SendOtp;
